<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: "App"
};
</script>

<style>
html, body{
    width: 100%;
    height: 100%;
    /* width: 1920px;
    height: 832px; */
    /* width: 4910px;
    height: 2160px; */
    margin: 0;
    padding: 0;
    background-color: #f5f5f5 !important;
    font-size: 16px !important;
}
#app {
    width: 100%;
    height: 100%;
}
@media screen and (min-width: 2400px){
    html, body{
        font-size: 24px !important;
    }
}
@media screen and (min-width: 3200px){
    html, body{
        font-size: 30px !important;
    }
}
@media screen and (min-width: 4000px){
    html, body{
        font-size: 40px !important;
    }
}
@media screen and (min-width: 5000px){
    html, body{
        font-size: 48px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue